<template>
  <div class="catalog-page-container">
    <img
        v-if="showArray(getCatalog?.catalogueBackground)"
        class="catalog-page-background-image"
        :src="getCatalog?.catalogueBackground"
        alt=""
      />
      <img
        v-else
        class="catalog-page-background-image"
        src="@/assets/img/catalogue_fallback_img.avif"
        alt=""
      />
    <!-- <div v-else class="catalog-page-background-default"></div> -->
    <div class="catalog-box">
      <slot name="header">
        <div
          class="catalog-header-container mx-auto d-flex justify-content-between align-items-center"
          ref="catHeader"
        >
          <div class="catalog-header-info d-flex">
            <div
              v-if="
                getCatalog?.catalogueFavIcon &&
                getCatalog?.catalogueFavIcon.length > 0
              "
            >
              <img
                class="catalog-header-title-icon"
                :src="getCatalog?.catalogueFavIcon"
                alt=""
              />
            </div>
            <div v-else>
              <img
                class="catalog-header-title-icon-fallback"
                :src="getImg(getCatalogImage(catalog))"
              />
            </div>
            <div class="catalog-header-title-text">
              <h1 class="catalog-header-title-title" aria-label="Katalogtitel">
                {{
                  getTranslationFor(
                    getCatalog?.title,
                    $route.query.locale,
                    getCatalog?.languages
                  )
                }}
              </h1>
              <h5 class="catalog-header-title-subtitle" aria-label="Homepage">
                <a 
                :href="getCatalog?.homepage" 
                target="_blank" 
                rel="noopener noreferrer" 
                class="catalog-homepage-link">
                {{ getCatalog?.homepage }}
              </a>
              </h5>
            </div>
          </div>
          <div
            v-if="
              getCatalog?.catalogueLogo && getCatalog?.catalogueLogo?.length > 0
            "
          >
            <img
              class="catalog-header-logo d-none d-sm-block"
              :src="getCatalog?.catalogueLogo"
              alt=""
            />
          </div>
          <!-- <div v-else>
            <img
              class="catalog-header-logo d-none d-sm-block"
              src="@/assets/img/img-not-available.png"
            />
          </div> -->
        </div>
      </slot>

      <div class="catalog-card card">
        <div class="card-header" role="navigation">
          <!-- CARD NAV -->
          <ul
            class="nav nav-tabs card-header-tabs"
            role="tablist"
            aria-label="Navigationsleiste"
          >
            <li
              v-for="tab in cardNavTabs"
              :key="tab.id"
              role="tab"
              :aria-controls="tab.id"
              :aria-selected="activeTabName === tab.id"
              :aria-label="tab.displayName"
            >
              <a
                @click.prevent="setActiveTabName(tab.id)"
                class="catalog-nav-link nav-link"
                :class="{ active: tab.id === activeTabName }"
                :href="`#${tab.id}`"
                role="tab"
              >
                {{ tab.displayName }}
              </a>
            </li>
          </ul>
        </div>
        <!-- CARD CONTENT -->
        <div class="card-body">
          <!-- "ÜBER DIESEN KATALOG" -->
          <div
            v-if="activeTabName === 'about'"
            class="tab-pane active catalog-about-tab"
            id="about"
            role="tabpanel"
          >
            <div class="row">
              <div class="col-12 col-md-8 order-1 order-md-1 d-flex flex-column">
                <app-markdown-content
                  class="card-text mb-3"
                  tag="div"
                  :text="
                    getTranslationFor(
                      catalog?.description,
                      $route.query.locale,
                      catalog?.languages
                    )
                  "
                />
              </div>
              <div class="col-12 col-md-4 order-2 order-md-2 mt-3 mt-md-0 pl-0">
                <img
                  v-if="showArray(getCatalog?.catalogueProfile)"
                  class="catalog-hero-pic img-fluid w-100"
                  :src="getCatalog?.catalogueProfile"
                  alt=""
                />
              </div>
              <div class="col-12 col-md-8 order-3 order-md-3 pt-3 pb-3">
                  <div class="grey-grid">
                    <div class="grid-item">
                      <strong>   {{ $t('message.metadata.publisher') }}</strong><br />{{ getCatalog?.publisher?.name }}
                    </div>
                    <div class="grid-item">
                      <strong>   {{ $t('message.metadata.languages') }}</strong><br />{{ getCatalog?.languages?.[0]?.id }}
                    </div>
                    <div class="grid-item">
                      <strong>{{ $t('message.metadata.created') }}</strong><br />{{ formattedDate(getCatalog?.issued) }}
                    </div>
                    <div class="grid-item">
                      <strong>{{ $t('message.metadata.updated') }}</strong><br />{{ formattedDate(getCatalog?.modified) }}
                    </div>
                    <!-- Dropdown -->
                  <div class="dropdown mt-3">
                    <button
                      href="#"
                      rel="noopener"
                      target="_self"
                      class="p-0 font-weight-bold  dropdown-toggle text-nowrap download-metadata"
                      role="button"
                      id="linkedDataDropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span
                        title=""
                        data-toggle="tooltip"
                        data-original-title="Options to download the catalogue metadata in various linked data representations."
                      >
                        Download Metadata
                      </span>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="linkedDataDropdownMenuLink">
                      <a
                        :href="createLinkedDataURL('rdf')"
                        rel="noopener"
                        target="_blank"
                        class="text-decoration-none dropdown-item"
                      >
                        RDF/XML
                      </a>
                      <a
                        :href="createLinkedDataURL('ttl')"
                        rel="noopener"
                        target="_blank"
                        class="text-decoration-none dropdown-item"
                      >
                        Turtle
                      </a>
                      <a
                        :href="createLinkedDataURL('n3')"
                        rel="noopener"
                        target="_blank"
                        class="text-decoration-none dropdown-item"
                      >
                        Notation3
                      </a>
                      <a
                        :href="createLinkedDataURL('nt')"
                        rel="noopener"
                        target="_blank"
                        class="text-decoration-none dropdown-item"
                      >
                        N-Triples
                      </a>
                      <a
                        :href="createLinkedDataURL('jsonld')"
                        rel="noopener"
                        target="_blank"
                        class="text-decoration-none dropdown-item"
                      >
                        JSON-LD
                      </a>
                    </div>
                  </div>
                  </div>
              </div>
            </div>
          </div>
          <!-- "INTERESSANTE DATENSÄTZE" -->
          <div
            v-show="activeTabName === 'dataset-selections'"
            class="tab-pane active"
            id="dataset-selections"
            role="tabpanel"
            aria-labelledby="dataset-selections-tab"
          >
            <div
              v-if="showArray(interestingDatasets)"
              class="tab-content d-flex flex-column align-items-center mt-3"
            >
              <div class="d-flex flex-wrap justify-content-center mb-5">
                <DatasetCard
                  v-for="dataset in interestingDatasets.length > 0
                    ? interestingDatasets.slice(0, 3)
                    : getDatasets.slice(0, 3)"
                  :key="dataset.id"
                  :to="`/datasets/${dataset.id}`"
                  :datasetTitle="
                    getTranslationFor(
                      dataset.title,
                      $route.query.locale,
                      dataset.languages
                    ) || dataset.id
                  "
                  :datasetDescription="
                    getTranslationFor(
                      dataset?.description,
                      $route.query.locale,
                      dataset.languages
                    )
                  "
                  :datasetCatalog="
                    getTranslationFor(
                      dataset?.catalog?.title,
                      $route.query.locale,
                      []
                    )
                  "
                  :descriptionMaxLength="175"
                  :data-cy="`dataset@${dataset.id}`"
                  class="mt-3"
                />
              </div>

              <button
                @click.prevent="setActiveTabName('dataset-page')"
                class="primary-button"
                role="button"
              >
                Mehr Daten entdecken
              </button>
            </div>

            <span v-else class="d-block py-5 no-datasets">No Featured Datasets</span>
          </div>
          

          <!-- "ALLE DATENSÄTZE" -->
          <div
            v-show="activeTabName === 'dataset-page'"
            class="tab-pane active"
            id="dataset-page"
            role="tabpanel"
            aria-labelledby="dataset-page-tab"
          >
            <slot name="card-datasets">
              <div class="tab-content mt-3">
                <component
                  :is="catalogSearchComponent"
                  :key="`${catalogSearchScope}-${catalogId}`"
                  id="deu-catalogue-page-dataset"
                />
              </div>
            </slot>
          </div>

          <!-- "KONTAKT" -->
          <div
            v-show="activeTabName === 'contact'"
            class="tab-pane active"
            id="contact"
            role="tabpanel"
            aria-labelledby="contact-tab"
          >
            <div class="tab-content py-5">
              <dl
                v-if="
                  has(getCatalog, 'publisher') &&
                  showObject(getCatalog.publisher) &&
                  (showString(getCatalog.publisher.email) ||
                    showString(getCatalog.publisher.homepage) ||
                    showObject(getCatalog.publisher.address))
                "
              >
                <p
                  v-if="
                    has(getCatalog, 'publisher.name') &&
                    showString(getCatalog?.publisher?.name)
                  "
                >
                  Get in touch with
                  <strong>{{ getCatalog?.publisher?.name }}</strong>
                </p>
                <!-- address -->
                <dd
                  v-if="
                    has(getCatalog, 'publisher.address') &&
                    showObject(getCatalog?.publisher?.address)
                  "
                >
                  <!-- E-Mail:  -->
                  <span
                    v-if="
                      has(getCatalog, 'publisher.address.street') &&
                      showString(getCatalog?.publisher?.address?.street)
                    "
                    >{{ getCatalog?.publisher?.address?.street }}</span
                  >
                </dd>
                <dd
                  v-if="
                    has(getCatalog, 'publisher.address') &&
                    showObject(getCatalog?.publisher?.address)
                  "
                >
                  <!-- E-Mail:  -->
                  <span
                    v-if="
                      has(getCatalog, 'publisher.address.postalCode') &&
                      showString(getCatalog?.publisher?.address?.locality) &&
                      has(getCatalog, 'publisher.address.locality') &&
                      showString(getCatalog?.publisher?.address?.postalCode)
                    "
                    >{{ getCatalog?.publisher?.address?.postalCode }}
                    {{ getCatalog?.publisher?.address?.locality }}</span
                  >
                </dd>
                <div class="container">
                  <!-- email -->
                  <dd>
                    <app-link
                      v-if="
                        has(getCatalog, 'publisher.email') &&
                        showString(getCatalog?.publisher?.email)
                      "
                      :to="getCatalog.publisher.email"
                    >
                      <div class="link-container">
                        <span class="icon">
                          <i
                            class="material-icons align-bottom ml-1"
                            style="
                              color: #0e47cb;
                              margin-top: 3px;
                              font-size: 48px;
                            "
                            >email</i
                          >
                        </span>
                        <a
                          class="contact-link mt-0"
                          :href="
                            getCatalog?.publisher?.email.startsWith('mailto:')
                              ? getCatalog?.publisher?.email
                              : 'mailto:' + getCatalog?.publisher?.email
                          "
                        >
                          {{
                            getCatalog?.publisher?.email.startsWith("mailto:")
                              ? getCatalog?.publisher?.email.slice(7)
                              : getCatalog?.publisher?.email
                          }}
                        </a>
                      </div>
                    </app-link>
                  </dd>
                  <!-- homepage -->
                  <dd>
                    <app-link
                      v-if="
                        has(getCatalog, 'publisher.homepage') &&
                        showString(getCatalog?.publisher?.homepage)
                      "
                      :to="getCatalog?.publisher?.homepage"
                    >
                      <div class="link-container">
                        <span class="icon">
                          <i
                            class="material-icons align-bottom ml-1"
                            style="
                              color: #0e47cb;
                              margin-top: 3px;
                              font-size: 48px;
                            "
                            >language</i
                          >
                        </span>
                        <a
                          class="contact-link mt-0"
                          :href="getCatalog?.publisher?.homepage" target="_blank"
                        >
                          {{ getCatalog?.publisher?.homepage }}
                        </a>
                      </div>
                    </app-link>
                  </dd>
                </div>
              </dl>
              <span v-else>
               No Contact Information Available
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datasets from "../Datasets.vue";
import Combined from "@/components/search/combined/Combined.vue";
import Dataservices from "@/components/search/dataservices/Dataservices.vue";
import Datasetseries from "@/components/search/datasetseries/Datasetseries.vue";
import EditorialContent from "@/components/search/editorial-content/EditorialContent.vue";
import { mapGetters, mapActions } from "vuex";
import DatasetCard from "./CatalogPageDatasetCard.vue";
import AppMarkdownContent from "./AppMarkdownContent.vue";
import { has, isArray, isNil, isObject, isString } from "lodash-es";
import { getTranslationFor, truncate } from "./helpers";
import datasetService from "./datasetService";
import Axios from "axios";
import { helpers } from "@piveau/piveau-hub-ui-modules";
const { getImg } = helpers;

export default {
  name: "CatalogPage",
  components: {
    Combined,
    Dataservices,
    Datasetseries,
    Datasets,
    EditorialContent,
    DatasetCard,
    AppMarkdownContent,
  },
  data() {
    return {
      interestingDatasets: [],
      interestingDatasetsFallback: [],
      activeTabName: "about",
      datasetService: null,
    };
  },
  computed: {
    ...mapGetters("catalogDetails", { catalogFromStore: "getCatalog" }),
    ...mapGetters("datasets", [
      "getDatasets",
      "getDatasetsCount",
      "getLoading",
      "getOffset",
    ]),
    getCatalog() {
      return this.catalogFromStore?.cat ?? this.catalogFromStore ?? {};
    },
    cardNavTabs() {
      return [
        {
          id: "about",
          displayName: this.$t('message.header.navigation.about.title'),
        },
        {
          id: "dataset-selections",
          displayName: "Featured datasets",
        },
        {
          id: "dataset-page",
          displayName: "All datasets",
        },
        {
          id: "contact",
          displayName: this.$t('message.header.subnav.contact'),
        },
      ];
    },
    catalog() {
      return this.getCatalog;
    },
    catalogSearchScope() {
      return this.$route.query.searchScope || "dataset";
    },
    catalogSearchComponent() {
      switch (this.catalogSearchScope) {
        case "combined":
          return "Combined";
        case "dataservice":
          return "Dataservices";
        case "datasetseries":
          return "Datasetseries";
        case "editorialContent":
          return "EditorialContent";
        default:
          return "Datasets";
      }
    },
    catalogId() {
      let catalogId = this.$route.params.ctlg_id;
      if (catalogId === undefined || catalogId === null) {
        const host = window.location.host;
        const parts = host.split(".");
        if (parts.length > 1) {
          catalogId = parts[0];
        }
      }
      return catalogId;
    },
  },
  methods: {
    isNil,
    // The imported Lodash has function. Must be defined in Methods so we can use it in template
    has,
    isArray,
    truncate,
    getImg,
    getTranslationFor,
    ...mapActions("catalogDetails", ["loadCatalog"]),
    ...mapActions("datasets", ["loadDatasets", "loadSingleDataset"]),
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    showObject(object) {
      return (
        !isNil(object) &&
        isObject(object) &&
        !Object.values(object).reduce(
          (keyUndefined, currentValue) =>
            keyUndefined && currentValue === undefined,
          true
        )
      );
    },
    showArrayOfStrings(stringArray) {
      return (
        this.showArray(stringArray) &&
        stringArray.every((currentString) => this.showString(currentString))
      );
    },
    showString(string) {
      return !isNil(string) && isString(string);
    },
    showArray(array) {
      return !isNil(array) && isArray(array) && array.length > 0;
    },
    showObjectArray(objectArray) {
      return (
        this.showArray(objectArray) &&
        !objectArray.reduce(
          (objectUndefined, currentObject) =>
            objectUndefined &&
            Object.values(currentObject).reduce(
              (keyUndefined, currentValue) =>
                keyUndefined && currentValue === undefined,
              true
            ),
          true
        )
      );
    },
    normalizeCatalog(catalog) {
      return catalog?.cat ?? catalog ?? {};
    },
    loadCatalogInterestingDatasets(catalog) {
      const normalizedCatalog = this.normalizeCatalog(catalog || this.catalog);
      const interestingDatasets = normalizedCatalog?.catalogueInterestingDatasets || [];
      for (let id of interestingDatasets) {
        this.loadSingleDataset(id)
          .then((response) => {
            this.interestingDatasets.push(response);
          })
          .catch((error) => {
            console.log("error: ", error);
          });
      }
    },
    loadCatalogInterestingDatasetsFallback(catalog) {
      const normalizedCatalog = this.normalizeCatalog(catalog || this.catalog);
      const interestingDatasets = normalizedCatalog?.catalogueInterestingDatasets || [];
      for (let id of interestingDatasets) {
        this.datasetService
          // .getSingle(id, (revision = ""))
          .getSingle(id)
          .then((response) => {
            this.interestingDatasetsFallback.push(response);
          })
          .catch((error) => console.log("error: ", error));
      }
    },

    formattedDate(data) {
      const isoDate = data;
      if (!isoDate) return "";
      const date = new Date(isoDate);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },

     getCatalogImage(catalog) {
      const normalizedCatalog = this.normalizeCatalog(catalog);
      const countryId = normalizedCatalog?.country?.id?.toLowerCase() === "europe"
        ? "eu"
        : normalizedCatalog?.country?.id;
      return this.$env.content.catalogs.useCatalogCountries
        ? `${this.$env.content.catalogs.defaultCatalogImagePath}/${
            countryId
              ? countryId
              : this.$env.content.catalogs.defaultCatalogCountryID
          }`
        : `${this.$env.content.catalogs.defaultCatalogImagePath}/${
            has(normalizedCatalog, "id")
              ? normalizedCatalog.id
              : this.$env.content.catalogs.defaultCatalogID
          }`;
    },
     createLinkedDataURL(format) {
      return `${this.$env.api.hubUrl}catalogues/${this.catalogId}.${format}`;
    },
  },
  mounted() {
    if (sessionStorage.activeTabName) {
      this.activeTabName = sessionStorage.activeTabName;
    }
  },
  watch: {
    activeTabName(activeTab) {
      sessionStorage.activeTabName = activeTab;
    },
  },
  created() {
    this.$Progress.start();

    // Hack: define fresh instance of datasetService to avoid going through store.
    // When going through store, it will cause mutations that will affect datasetDetails page.
    this.datasetService = new datasetService(
      this.$env.api.baseUrl,
      this.$env.api.hubUrl,
      this.$env.api.qualityBaseUrl,
      this.$env.api.similarityBaseUrl,
      this.$env.api.similarityServiceName,
      this.$env.content.datasets.facets.scoringFacets.defaultScoringFacets
    );

    let catalogId = this.$route.params.ctlg_id;
    if (catalogId === undefined || catalogId === null) {
      const host = window.location.host;
      const parts = host.split(".");
      if (parts.length > 1) {
        catalogId = parts[0];
      }
    }
    Promise.all([
      this.loadCatalog(catalogId).then((result) => {
        this.loadCatalogInterestingDatasets(result);
      }),
      // TODO: This is a temporary workaround.
      // We should refactor this code to use the store instead of making
      // a dedicated HTTP request for dataset search.
      // This will ensure that the most relevant datasets for the catalog are always displayed,
      // even if the search page has filtered datasets.
      Axios.get(`${this.$env.api.baseUrl}search`, {
        params: {
          q: "",
          filter: "dataset",
          limit: 3,
          page: 0,
          sort: "relevance+desc,+modified+desc,+title.de+asc",
          facetOperator: "AND",
          facetGroupOperator: "AND",
          dataServices: false,
          includes:
            "id,title.de,description.de,languages,modified,issued,catalog.id,catalog.title,catalog.country.id,distributions.id,distributions.format.label,distributions.format.id,distributions.license,categories.label,publisher",
          facets: JSON.stringify({
            license: [],
            format: [],
            categories: [],
            catalog: [catalogId],
            publisher: [],
            country: [],
          }),
        },
      })
        .then((response) => {
          const interestingDatasets = response.data?.result?.results || [];
          this.loadCatalogInterestingDatasetsFallback(interestingDatasets);
        })
        .catch((error) => {
          console.error(error);
        }),
      // ...this.activeTabName === 'dataset-page' ? [this.loadDatasets({locale: this.$route.query.locale})] : [],
    ])
      .then(() => {
        this.$Progress.finish();
      })
      .catch((error) => {
        console.error(error);
        this.$Progress.fail();
      });
  },
};
</script>

<style lang="scss" scoped>

.ecl-container {
  padding-bottom: 0px !important;
}


.no-datasets {
color: #696969;
}

.download-metadata {
  color: #0e47cb !important;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  outline: inherit;
}
.catalog-page-container {
  margin-top: -10px !important;
  padding: 0 !important;
}

.catalog-page-background-image,
.catalog-page-background-default {
  position: absolute;
  height: 360px;
  width: 100%;
}

.catalog-page-background-default {
  background-color: #f4f8fa;
}

.catalog-page-background-image {
  overflow: hidden;
  object-fit: cover;
  filter: brightness(0.9);
  opacity: 0.3;
}

.catalog-box {
  display: flex;
  flex-direction: column;
  margin-bottom: 95px;
}

.flag-img {
  width: 150px;
  height: auto;
}

.catalog-header-container {
  flex: 1 1 100%;
  width: 100%;
  max-width: 1250px;
  min-height: 180px;
  padding-left: 32px !important;
  padding-right: 32px;
  z-index: 1;
}

.catalog-header-title-subtitle {
  font-size: 18px;
}

.catalog-header-title-icon {
  height: 50px;
  margin-right: 16px;
  border-radius: 50%;
}
.catalog-header-title-icon-fallback {
  // height: 45%;
  // width: 70px;
  height: 50px;
  margin-right: 16px;
  // margin-top: 10px;
  border-radius: 10%;
}
.catalog-header-logo {
  max-height: 80px !important;
  max-width: 192px !important;
  height: auto;
  width: auto;
  margin-right: 70px !important;
}

.catalog-card {
  flex: 1 1 100%;
  padding: 32px;
  width: 100%;
  max-width: 1220px;
  border: none;
}

.catalog-about-tab {
  flex-direction: column;
  flex-wrap: wrap;

  align-items: flex-start;
  gap: 30px;
  margin-top: 20px;
  padding-top: 20px;
  padding-left: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.catalog-about-tab > .tab-content {
  flex: 1 1 60%;           
  min-width: 300px;
}

.card-header {
  background-color: transparent;
  padding: 0;
}

.card-header-tabs {
  margin-right: 0;
  margin-left: 0;
  margin-bottom: 0;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.card-header-tabs li {
  padding-right: 48px;
}

.card-header-tabs li:last-child {
  padding-right: 0;
}

.card-body {
  padding: 0;
}

.catalog-nav-link.nav-link {
  color: rgba(0, 0, 0, 0.7);
  padding-left: 0;
  padding-right: 0;
  margin-bottom: 0;
  background-color: transparent;
  border: 0;
  border-left: 0;
  border-right: 0;
  border-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom: 2px solid transparent !important;

  &:hover,
  &.active {
    color: #0e47cb !important;
  }

  &.active {
    border-bottom: 2px solid #0e47cb !important;
  }
}

.catalog-hero-pic {
  flex: 0 0 auto;          
  max-width: 250px !important;
  height: auto;
  margin: 0 0 0 1.5rem;
  margin-top: calc(48px - 1rem);
}

.catalog-contact-header {
  font-size: 18px;
  margin-bottom: 34px;
}

.tab-content dt {
  margin-bottom: 8px;
}

.tab-content dd {
  margin-bottom: 0;
}
.grey-grid{
  background-color: #F3F6FC !important;
  border-radius: 20px;
  padding: 20px 30px; 
  margin-top: 25px;
  box-sizing: border-box;
}

@media screen and (min-width: 768px) {
  .catalog-header-container {
    padding-left: 0;
    padding-right: 0;
  }

  .catalog-box {
    padding-left: 32px;
    padding-right: 32px;
  }

  .catalog-card {
    border: none;
    box-shadow: 0px 2px 12px 0px #00000012;
    padding-left: 48px;
    padding-right: 48px;
    max-width:1100px !important;
    margin:0 auto !important
  }

  .catalog-about-tab {
    flex-wrap: nowrap;
    flex-direction: row;
  }

  .catalog-hero-pic {
    margin-top: 0;
    margin-left: 1.5rem;
  }
  .icon {
    font-size: 20px;
    margin-right: 15px;
  }
  .catalog-header-info{
    margin: 38px !important;
  }

  .link-container {
  background-color: #F3F6FC;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  text-decoration: underline;
  color: #0e47cb;
  text-decoration-color: #0e47cb;
  padding: 0.5em 1em; 
  white-space: nowrap; 
  margin-right: 2.0em; 
}
  .container {
    display: flex;
    align-items: center;
    margin-right: 20px;
    padding-left: 0px;
    margin-top: 45px;
  }
  .catalog-header-title-title {
    padding-left: 0px;
    font-weight: bold;
    font-size: 2.5rem !important;
    line-height: 2.5rem !important;
  }
  .content {
    margin: 20px;
  }
  .grey-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  justify-items: start;
  background-color: #F3F6FC;
  border-radius: 20px;
  padding: 20px 30px; 
  margin-top: 25px;
  box-sizing: border-box;
}

.grid-item strong {
  color: #4b4453;
  font-weight: bolder;
}
.grid-item {
  padding: 15px 8px;
}
.download-metadata {
  color: #0e47cb !important;
}
.tab-content {
  display: flex;
  flex-direction: column;
}
.catalog-homepage-link {
  color: black;             
  cursor: pointer;
}
.catalog-homepage-link:visited {
  color: black;
}
.catalog-homepage-link:hover {
  color: black;
  text-decoration: underline;
}
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .grey-grid {
    grid-template-columns: 1fr;
  }
}
</style>
<style lang="scss">
#deu-catalogue-page-dataset{
  .datasets{
    width:auto !important;
  }
}
</style>
